export default __webpack_public_path__ + "3db262881f81b6cf60a298d6a4623f04.png";